import React from 'react';
import '../assets/styles/ProjectRequestCard.css';

const ProjectsRequestCard = ({ project }) => {
  // Function to get the names of sectors, domains and cities separated by commas
  const getFormattedList = (items) => {
    return items.map(item => item.name).join(', ');
  };

  return (
    <div className="project-request-card">
      <div>{project.sectors && project.sectors.length > 0 ? getFormattedList(project.sectors) : 'No sector'}</div>
      <div>{project.practices && project.practices.length > 0 ? getFormattedList(project.practices) : 'No domain'}</div>
      <div>{project.cities && project.cities.length > 0 ? getFormattedList(project.cities) : 'No cities'}</div>
      <div>{project.experience_level || 'Level of experience unknown'}</div>
      <div>{project.title || 'Unknown title'}</div>
      <div>{project.contact_name || 'Contact not available'}</div>
    </div>
  );
};

export default ProjectsRequestCard;